import React, { Component } from 'react';
import PropTypes from 'prop-types';

import UserContext from 'contexts/User';

class User extends Component {
	componentWillMount() {
		this.props.userOpenHandler(false);
	}

	render() {
		return (
			<UserContext.Consumer>
				{ user => (
					<p>{user.firstName} {user.lastName}</p>
				)}
			</UserContext.Consumer>
		);
	}
}

User.propTypes = {
	userOpenHandler: PropTypes.func,
}

export default User;
